module.exports = __webpack_public_path__ + "static/media/sedan.5da95721.svg";